import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Rotas} from "src/app/core/rotas";
import {BaseService} from "../base/base.service";
import {Feriado} from "../../core/feriado";

@Injectable({
    providedIn: "root",
})
export class FeriadoService extends BaseService<Feriado> {
    constructor(http: HttpClient) {
        super(http, Rotas.FERIADO);
    }

    getFilter(descricao: string ,
              data: number) {
        const params: any = {};

        if (descricao) params.descricao = descricao;
        if (data) params.data = data;

        return this.http.get(Rotas.FERIADO + "filter", {params});
    }

}
	